import React from 'react';
import Spacer from "../../Spacer";

const ContactUs = () => {
    return (
        <>
            <p className="mb-3 text-lg text-gray-500 md:text-xl dark:text-gray-400">
                Thank you for your interest in our
                platform. If you have any questions or feedback, please feel free to
                contact us. Our team is dedicated to providing the best user experience and will do everything we can to
                assist you.</p>

            <Spacer axis="vertical" size={30}/>
            <p className="text-left text-gray-500 dark:text-gray-400"> To reach out to us, you may send an email
                to <strong>info@aviani.org</strong>.
                We promise to respond to your inquiry as soon as possible. We also encourage you to follow us on social
                media to stay
                up-to-date with the latest news and updates
                about our app. You can find us on Twitter.</p>


            <Spacer axis="vertical" size={30}/>

            <p className="text-left text-gray-500 dark:text-gray-400"> Thank you again for choosing Investitum. We value
                your
                feedback and are committed to making your
                experience with our app a positive one.</p>
        </>
    )
}
export default ContactUs